import PriceRowAgentHubCommission from 'agentHub/components/PriceRowAgentHubCommission'
import FormatCurrency from 'components/Common/FormatCurrency'
import CruisesDiscountTsAndCsModal from 'components/Cruises/CruisesDiscountTsAndCsModal'
import PriceRowCaption from 'LuxKit/PricePoints/PriceRowCaption'
import PriceRowPriceCaption from 'LuxKit/PricePoints/PriceRowPriceCaption'
import PriceRowTaxesAndFees from 'LuxKit/PricePoints/PriceRowTaxesAndFees'
import PriceRowValueDiscountWithCaption from 'LuxKit/PricePoints/Value/PriceRowValueDiscountWithCaption'
import LuxPlusPriceStack from 'luxPlus/components/LuxPlusPriceStack'
import LuxPlusLabel from 'LuxKit/Label/LuxPlusLabel'
import ModalContext from 'contexts/ModalContext'
import type { CruiseOfferView } from 'hooks/Cruise/useCruiseOfferView'
import useCruiseSelectedCabinType from 'hooks/useCruiseSelectedCabinType'
import { useCallback, useContext } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
interface Props {
  view: CruiseOfferView
}

function CruiseSearchTilePricing({ view }: Props) {
  const intl = useIntl()
  const {
    lowestPrice,
    memberLowestPrice,
    canSeeLuxPlusLabel,
    discountPills,
  } = view

  const selectedCabinType = useCruiseSelectedCabinType(view.cruiseType)

  const showModal = useContext(ModalContext)

  const openDiscountTermsAndConditionsModal = useCallback(() => {
    showModal(<CruisesDiscountTsAndCsModal />)
  }, [showModal])

  const twinShareLabel = intl.formatMessage({
    id: 'Zez7WNfVlG415oswa9hq',
    defaultMessage: 'Twin Share',
    description: 'Cruise cabin pricing basis label in the cruise offer or booking section',
  })

  const priceCaption = selectedCabinType
    ? intl.formatMessage(
        {
          id: 'Cslp2c34XbFUSRznteOE',
          defaultMessage: '{cabinType} from',
          description: 'Cruise search tile price caption with cabin type in the cruises section',
        },
        { cabinType: selectedCabinType },
      )
    : intl.formatMessage({
        id: 'SyeN89mAiH2FxiXDKqiw',
        defaultMessage: 'From',
        description: 'Cruise search tile price caption without cabin type',
      })

  return <div>
    <PriceRowPriceCaption>{priceCaption}</PriceRowPriceCaption>
    {lowestPrice && <LuxPlusPriceStack
      size="L"
      price={lowestPrice.primaryPrice.total}
      memberPrice={memberLowestPrice?.primaryPrice.total}
      saleUnit={lowestPrice.primaryPrice.type}
    />}
    {lowestPrice?.secondaryPrice && <PriceRowCaption>
      <FormattedMessage
        id="tS3bNBvwd_j1ZcVYvSzQ"
        defaultMessage="{price} /{priceType} · {twinShare}"
        description="Cruise search tile secondary price with type and twin share label"
        values={{
          price: <FormatCurrency value={lowestPrice.secondaryPrice.total} />,
          priceType: lowestPrice.secondaryPrice.type,
          twinShare: twinShareLabel,
        }}
      />
    </PriceRowCaption>}
    {!lowestPrice?.secondaryPrice && discountPills?.price && discountPills.discountPercentage && <PriceRowValueDiscountWithCaption
      size="M"
      originalValue={discountPills.price}
      discountPercentage={discountPills.discountPercentage}
      onInfoIconClick={openDiscountTermsAndConditionsModal}
    />}
    {canSeeLuxPlusLabel && <LuxPlusLabel
      type="member-price-offer-cruise"
    />}
    {!lowestPrice?.secondaryPrice && <PriceRowCaption>{twinShareLabel}</PriceRowCaption>}
    <PriceRowTaxesAndFees />
    <PriceRowAgentHubCommission
      offerId={view.offer.id}
      offer={view.offer}
      productType={view.offer.productType}
    />
  </div>
}

export default CruiseSearchTilePricing
